import React from "react";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import classNames from "classnames";

const MetaInfos = ({ content }) => {
  const { simpleDesign } = useAccessibilityContext();
  const infoClassNames = simpleDesign ? "tag" : "meta-info body-m";

  return (
    <div className="meta-infos">
      {/*content.fieldParticipantType && content.fieldParticipantType !== "act" &&
        <div className="meta-info concert body-m">
          {content.fieldParticipantType?.capitalize()}
        </div>
      */}

      <>
        {/* All Acts are Concerts */}
        {content.fieldParticipantCategory && content.fieldParticipantCategory?.name && (
          <div className={infoClassNames}>{content.fieldParticipantCategory?.name}</div>
        )}

        {simpleDesign && content?.fieldEventType && content.fieldEventType?.name && (
          <div className={infoClassNames}>{content.fieldEventType?.name}</div>
        )}

        {content?.fieldFormat && content?.fieldFormat?.length > 0 && content.fieldFormat[0]?.name && (
          <div className={infoClassNames}>{content.fieldFormat[0]?.name}</div>
        )}

        {/* Events are having different types */}
        {content?.fieldMainTopic?.length > 0 && [...content?.fieldMainTopic].splice(0, content?.fieldMainTopic.length === 1 ? 1 : 2).map(
          (item, index) => (
            <>
              {item?.name &&
                <div className={infoClassNames} key={`main-topic-${index}`}>{item.name}</div>
              }
            </>
          )
        )}
      </>

      {content.fieldMood && (
        <div className="meta-info mood body-m">{content.fieldMood.name}</div>
      )}

      {content.fieldGenre &&
        content.fieldGenre.map((genre, genreId) => (
          <div className="meta-info genre body-m" key={genreId}>
            {genre.name}
          </div>
        ))}

      {content.fieldSpokenLanguage &&
        content.fieldSpokenLanguage.map((language, languageId) => (
          <div className="meta-info language body-m" key={languageId}>
            {language?.fieldLanguageId}
          </div>
        ))}

      {!!content.fieldCountry?.list?.length && (
        <>
          {content.fieldCountry.list.map((country) => (
            <div className="meta-info country body-m" key={country}>
              {country?.value}
            </div>
          ))}
        </>
      )}

      {content.fieldInvitationOnly && (
        <div className="meta-info invitation-only body-m">Invitation only</div>
      )}
    </div>
  );
};

export default MetaInfos;
